<!--
 * @Author: <郭敏>
 * @Date: 2021-06-15 10:50:23
 * @LastEditTime: 2021-06-15 10:50:23
 * @LastEditors: Please set LastEditors
 * @Description: 带货类型展示组件
 * @FilePath: \partner.chaoyongtuan.com\src\views\shopManage\orderDetails\list\components\tableCell\mediaCell.vue	
-->
<template>
	<div class="media-cell">
		<div class="media-head">
			<div class="media-name font-h6-medium fz-12">{{ row.media_type_desc | formatEmpty }}</div>
		</div>
		<div v-if="isValidMediaId" class="media-bottom font-h6-medium fz-12">
			<el-tooltip placement="top" :open-delay="300">
				<div slot="content">
					<span class="ml-4">{{ row.media_id_new || '-' }}</span>
					<i class="el-icon-copy-document cursor-pointer ml-4 mt-2 hover" @click="handleCopy(row.media_id_new)"></i>
				</div>
				<div class="font-h6-medium fz-12 pointer">直播/视频ID：{{ row.media_id_new | textFormat(10)}}</div>
			</el-tooltip>
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
import { copy } from '@/utils/common';
export default {
	mixins: [mixin],
	components: {},
	data() {
		return {};
	},
	computed: {
        isValidMediaId() {
            return ![null, undefined, 0, '0'].includes(this.row.media_id_new);
        }
    },
	methods: {
		handleCopy(id) {
			copy(id);
			this.$message.success('复制成功');
		},
	},
};
</script>
<style lang="less" scoped>
.media-head {
	display: flex;
	align-items: center;
	.media-name {
		color: @color-text-primary;
	}
}
.media-bottom {
	color: #4e596a;
}
</style>